<template>
  <div>
    <ViewAttachments></ViewAttachments>
  </div>
</template>
  
  <script>
const ViewAttachments = defineAsyncComponent(() =>
  import("@/components/cases/AttachmentsView")
);
import { defineAsyncComponent } from "vue";
export default {
  components: {
    ViewAttachments,
  },
};
</script>
  
